import React from "react";
import clx from "classnames";
import styles from "./TableHeaderCell.module.css";

const TextAlign = {
    left: "!text-left",
    center: "!text-center",
    right: "!text-right",
};

export type TableCellHeaderAlignment = keyof typeof TextAlign;

interface Props {
    children: React.ReactNode;
    hiddenMobile?: boolean;
    maxWidth?: string;
    minWidth?: string;
    align?: TableCellHeaderAlignment;
    onClick?: () => void;
}


const TableHeaderCell = ({ children, hiddenMobile, maxWidth, minWidth, onClick, align }: Props) => {
    const cn = clx(
        {
            "hidden md:table-cell": hiddenMobile,
            [styles.tableHeaderCell]: true,
        },
        align ? TextAlign[align] : ""
    );

    return (
        <th
            className={cn}
            style={{
                maxWidth,
                minWidth,
            }}
            onClick={onClick}
        >
            {children}
        </th>
    );
};

export default TableHeaderCell;
